var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8438 19.3281L14.8047 14.2891C14.7266 14.2109 14.6094 14.1719 14.4922 14.1719H14.0625C15.4297 12.6875 16.25 10.7734 16.25 8.625C16.25 4.17188 12.5781 0.5 8.125 0.5C3.63281 0.5 0 4.17188 0 8.625C0 13.1172 3.63281 16.75 8.125 16.75C10.2344 16.75 12.1875 15.9297 13.6328 14.6016V14.9922C13.6328 15.1484 13.6719 15.2656 13.75 15.3438L18.7891 20.3828C18.9844 20.5781 19.2578 20.5781 19.4531 20.3828L19.8438 19.9922C20.0391 19.7969 20.0391 19.5234 19.8438 19.3281ZM8.125 15.5C4.29688 15.5 1.25 12.4531 1.25 8.625C1.25 4.83594 4.29688 1.75 8.125 1.75C11.9141 1.75 15 4.83594 15 8.625C15 12.4531 11.9141 15.5 8.125 15.5Z",
    fill: "#666666"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.31814f77.svg";
export { ForwardRef as ReactComponent };